import { useTranslation } from '@thoughtspot/i18n';
import { Button } from '@thoughtspot/radiant-react/widgets/button';
import { Icon, IconID } from '@thoughtspot/radiant-react/widgets/icon';
import { Horizontal, Vertical, } from '@thoughtspot/radiant-react/widgets/layout';
import { Typography } from '@thoughtspot/radiant-react/widgets/typography';
import React from 'react';
import Draggable from 'react-draggable';
import { HelpMenuState, HelpMenuTestIds } from "./help-menu.const";
import styles from './help-menu.module.scss';
const FRAME_WIDTH = 480;
const FRAME_HEIGHT = 551;
export const DocumentationFrame = ({ documentationUrl, setHelpMenuState, }) => {
    const { t } = useTranslation();
    return (React.createElement(Draggable, null,
        React.createElement("div", null,
            React.createElement(Vertical, { className: styles.documentationDraggable },
                React.createElement(Vertical, { className: styles.documentationHeader },
                    React.createElement(Horizontal, { hAlignContent: "center" },
                        React.createElement(Icon, { id: IconID.DRAG_HANDLE, className: styles.dragHandle })),
                    React.createElement(Typography, { variant: "modal-title" }, t('Help'))),
                React.createElement("iframe", { "data-testid": HelpMenuTestIds.Documentation, title: t('help.helpWidgetUrl.documentation.TITLE'), src: documentationUrl, width: FRAME_WIDTH, height: FRAME_HEIGHT, className: styles.documentationFrame }),
                React.createElement(Horizontal, { vAlignContent: "center", hAlignContent: "right", className: styles.documentationFooter },
                    React.createElement(Button, { type: "primary", text: t('CLOSE'), onClick: () => setHelpMenuState(HelpMenuState.CLOSED) }))))));
};
//# sourceMappingURL=documentation-iframe.js.map